module.exports = "th, td{\r\n    text-align: center;\r\n  }\r\nthead tr {\r\n    background-color: #ecf6fc;\r\n  }\r\n.table>thead>tr>th{\r\n    border-bottom: 0;\r\n    vertical-align: top;\r\n  }\r\n.table-rtgs td{\r\n    border: 1px solid #000000;\r\n    border-collapse: collapse;\r\n  }\r\n.business-list-item\r\n{\r\n    color: #000;\r\n    padding: 12px 19px;\r\n}\r\n.business-list-item:hover\r\n{\r\n    background-color: #d77229;\r\n    cursor: pointer;\r\n    color: #fff !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/reports.component.css
// module id = ./src/app/reports/reports.component.css
// module chunks = main